<div class="aig-ibanfield e-field u-mb-0" [formGroup]="parentForm">
  <label for="iban1" class="e-field__label">
    IBAN
    <span class="u-color-warning-error" [ngClass]="mandatory ? '' : 'u-ds-none'"
      >*</span
    >
  </label>

  <div class="aig-ibanfield__block">
    <!-- <span class="es">ES</span> -->
    <div class="p-flexcc">
      <input
        type="text"
        class="e-field__input iban1 form-control u-border-0 u-p-0"
        id="iban1"
        formControlName="iban1"
        maxlength="2"
        autocomplete="on"
        placeholder="00"
        (keyup)="checkIban('iban1')"
      />
    </div>

    <input
      type="text"
      class="e-field__input form-control"
      id="iban2"
      formControlName="iban2"
      autocomplete="on"
      maxlength="4"
      placeholder="0000"
      min="0"
      max="9999"
      (keyup)="checkIban('iban2')"
    />

    <input
      type="text"
      class="e-field__input form-control"
      id="iban3"
      formControlName="iban3"
      autocomplete="on"
      (keyup)="checkIban('iban3')"
      maxlength="4"
      min="0"
      max="9999"
      placeholder="0000"
    />

    <input
      type="text"
      class="e-field__input form-control"
      id="iban4"
      formControlName="iban4"
      autocomplete="on"
      (keyup)="checkIban('iban4')"
      maxlength="2"
      min="0"
      max="99"
      placeholder="00"
    />

    <input
      type="text"
      class="e-field__input form-control"
      id="iban5"
      formControlName="iban5"
      autocomplete="on"
      (keyup)="checkIban('iban5')"
      maxlength="10"
      min="0"
      max="9999999999"
      placeholder="0000000000"
    />
  </div>
  <div class="u-text-end">
    <span
      class="e-field__error"
      *ngIf="this.parentForm.controls['iban5']?.errors?.['required'] && this.parentForm.controls['iban5']?.touched"
    >
      IBAN es obligatorio.
    </span>
    <span
      class="e-field__error"
      *ngIf="invalidIban && this.parentForm.controls['iban5']?.touched"
      id="errorIban"
    >
      IBAN no válido
    </span>
  </div>
</div>
